import HeaderCom from "../../components/Header.vue";
import http from "../../api/module";
import pagination from "../../components/pagination";

export default {
  name: "queryStudent",
  data() {
    var checkOldPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      currentPage: 1, // 当前页
      limit: 10, // 每页显示数量
      total: 0, // 总条目数
      infoList: [],
      specialList: JSON.parse(sessionStorage.getItem("specialList")),
      dataForm: {},
      formInline: {},
      organs: [],
      tableData: [],
      selection: [],
      dialogVisible: false,
      ruleForm: {
        empIds: "",
        password: "",
      },
      rules: {
        password: [{ validator: checkOldPass, trigger: "blur" }],
      },
    };
  },
  components: {
    HeaderCom,
    pagination,
  },
  created() {
    this.organs = JSON.parse(sessionStorage.getItem("organs"));
  },
  mounted() {
    this.getInfo();
  },
  computed: {},
  methods: {
    organChange(val) {
      this.entpName = val;
    },
    specialChange(val) {
      this.postName = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getInfo();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.currentPage = 1;
      this.getInfo();
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getInfo();
    },
    // 获取列表信息
    getInfo() {
      this.loading = true;
      http
        .getUserInfo({
          pageNum: this.currentPage,
          pageSize: this.limit,
          entpName: this.formInline.entpName,
          empName: this.formInline.regName,
          empSex: this.formInline.regSex,
          empIdcard: this.formInline.regIdcard,
          empTel: this.formInline.regTel,
          affiliatedEnterprise: this.formInline.affiliatedEnterprise,
          postName: this.postName,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.infoList = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: "error",
              duration: 1000,
              message: data.data.message,
            });
            // this.$router.push({
            //   path: '/login'
            // })
            // window.open(`http://bdy.eceyun.net/school/home`);
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 1000,
            message: "请求失败，请联系管理员！",
          });
        });
    },
    // 当某一行被点击时触发
    rowClick(row, column, event) {
      this.$refs.fileTable.toggleRowSelection(row);
    },

    // 当选择项发生变化时触发
    selectioChange(selection) {
      this.selection = selection;
      let empIds = [];
      this.selection.forEach((item) => {
        empIds.push(item.empId);
      });
      this.ruleForm.empIds = empIds.join(",");
    },

    // 批量重置密码
    batchReset() {
      if (this.selection.length == 0) {
        this.$message({
          type: "error",
          duration: 1000,
          message: "请选择学员！",
        });
        return false;
      }
      this.dialogVisible = true;
    },

    /* 弹框表单清空 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          http
            .registrationEmployeeModifyPassword(this.ruleForm)
            .then((data) => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message.success({
                  duration: 1000,
                  message: "密码修改成功！",
                });
                this.dialogVisible = false;
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                duration: 1000,
                message: "请求失败，请联系管理员！",
              });
            });
        }
      });
    },
  },
};
